(() => {
  const menu = document.querySelector('.bb-shop-menu');
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && menu?.open) { menu.open = false; menu.querySelector('summary').focus(); }
  });
  document.addEventListener('click', event => { if (menu?.open && !menu.contains(event.target)) menu.open = false; });
  document.querySelector('[data-catalog-sort]')?.addEventListener('change', event => event.target.form.requestSubmit());
  window.addEventListener('bb:cart:updated', async () => {
    try {
      const response = await fetch('/cart.js', {headers:{Accept:'application/json'}});
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('[data-bb-cart-template]').forEach(link => {
        const label = link.dataset.bbCartTemplate.replace('__COUNT__', String(cart.item_count));
        link.setAttribute('aria-label', label);
        const counter = link.querySelector('[data-bb-cart-count]');
        if (counter) counter.textContent = cart.item_count;
        const fullLabel = link.querySelector('[data-bb-cart-label]');
        if (fullLabel) fullLabel.textContent = label;
      });
    } catch {}
  });
})();
